function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 495 495",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CBA68"
    },
    d: "M173.5,383.294c22.799,12.436,48.468,18.99,74.592,18.999h0.064 c86.027,0,156.056-70.025,156.091-156.089c0.016-41.707-16.205-80.924-45.675-110.427C329.102,106.273,289.91,90.017,248.154,90 c-86.035,0-156.058,70.018-156.092,156.08c-0.012,27.511,7.176,54.363,20.836,78.035L90.753,405L173.5,383.294z M248.207,116.363 c34.653,0.012,67.227,13.525,91.722,38.047c24.494,24.522,37.976,57.118,37.963,91.784 c-0.029,71.536-58.229,129.737-129.736,129.737h-0.053c-23.28-0.009-46.113-6.263-66.032-18.084l-4.737-2.812l-49.103,12.881 l13.106-47.875l-3.085-4.909c-12.987-20.656-19.846-44.529-19.836-69.044C118.445,174.559,176.645,116.363,248.207,116.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CBA68"
    },
    d: "M251.394,310.652c9.305,4.019,16.57,6.418,22.234,8.215c9.343,2.969,17.846,2.55,24.566,1.546 c7.493-1.119,23.075-9.434,26.326-18.544c3.249-9.112,3.249-16.921,2.274-18.547c-0.975-1.627-3.575-2.603-7.475-4.556 c-3.9-1.952-23.075-11.386-26.65-12.689c-3.575-1.301-6.175-1.951-8.775,1.952c-2.6,3.904-10.074,12.69-12.35,15.293 c-2.275,2.602-4.55,2.929-8.449,0.976c-3.9-1.952-16.467-6.07-31.364-19.358c-11.595-10.342-19.422-23.114-21.697-27.018 c-2.275-3.904-0.243-6.015,1.71-7.959c1.755-1.748,3.901-4.556,5.85-6.833c1.95-2.277,2.6-3.905,3.9-6.506 c1.3-2.604,0.65-4.881-0.325-6.833c-0.975-1.952-8.775-21.15-12.025-28.96c-3.166-7.604-6.381-6.574-8.775-6.695 c-2.272-0.113-4.875-0.137-7.475-0.137c-2.6,0-6.826,0.976-10.4,4.88c-3.575,3.905-13.65,13.341-13.65,32.537 c0,19.198,13.975,37.743,15.925,40.346C186.717,254.364,212.269,293.758,251.394,310.652z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3FA45A"
    },
    points: "247.5,0 247.5,40 455,40 455,455 247.5,455 247.5,495 495,495 495,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4CBA68"
    },
    points: "40,455 40,40 247.5,40 247.5,0 0,0 0,495 247.5,495 247.5,455  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b4e7f4523176e5790c32dfb30581e248.svg";
export { ForwardRef as ReactComponent };